(function () {
  if (window.__whatsappCartInit) return;
  window.__whatsappCartInit = true;

  function formatUSD(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function formatBRL(val) {
    try {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(val);
    } catch (e) {
      return 'R$ ' + val.toFixed(2).replace('.', ',');
    }
  }

  function formatPYG(val) {
    try {
      return '₲ ' + new Intl.NumberFormat('es-PY', { maximumFractionDigits: 0 }).format(val);
    } catch (e) {
      return '₲ ' + Math.round(val).toLocaleString();
    }
  }

  function manualRates() {
    if (!window.__manualRatesEnabled) return null;
    var brl = parseFloat(window.__manualRateBRL);
    var pyg = parseFloat(window.__manualRatePYG);
    if (isNaN(brl) || isNaN(pyg)) return null;
    return { BRL: brl, PYG: pyg };
  }

  function fetchRates() {
    var manual = manualRates();
    if (manual) return Promise.resolve(manual);

    var CACHE_KEY = 'cp_fx_rates_v2';
    var CACHE_EXPIRY = 'cp_fx_expiry_v2';
    var ONE_HOUR = 3600000;
    var stored, expiry;
    try {
      stored = localStorage.getItem(CACHE_KEY);
      expiry = localStorage.getItem(CACHE_EXPIRY);
    } catch (e) {}
    if (stored && expiry && Date.now() < parseInt(expiry, 10)) {
      return Promise.resolve(JSON.parse(stored));
    }
    return fetch('https://open.er-api.com/v6/latest/USD')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var rates = { BRL: data.rates.BRL, PYG: data.rates.PYG };
        try {
          localStorage.setItem(CACHE_KEY, JSON.stringify(rates));
          localStorage.setItem(CACHE_EXPIRY, String(Date.now() + ONE_HOUR));
        } catch (e) {}
        return rates;
      });
  }

  function ensureProtocol(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return 'https:' + url;
    return url;
  }

  function buildCartMessage(cart, rates, showRates) {
    var lines = ['Ola! Quero finalizar meu pedido:', ''];

    cart.items.forEach(function (item) {
      var line = item.quantity + 'x ' + item.product_title;
      if (item.variant_title && item.variant_title !== 'Default Title') {
        line += ' (' + item.variant_title + ')';
      }
      line += ' - ' + formatUSD(item.final_line_price);
      lines.push(line);

      var imageUrl = ensureProtocol(item.image);
      if (imageUrl) lines.push(imageUrl);

      lines.push('');
    });

    var totalUsd = cart.total_price / 100;
    var totalLine = 'Total: ' + formatUSD(cart.total_price);
    if (showRates && rates) {
      totalLine += ' (aprox ' + formatBRL(totalUsd * rates.BRL) + ' / ' + formatPYG(totalUsd * rates.PYG) + ')';
    }
    lines.push(totalLine);

    return lines.join('\n');
  }

  function setLoading(el, isLoading) {
    el.classList.toggle('whatsapp-checkout-button--loading', isLoading);
    el.toggleAttribute('disabled', isLoading);
  }

  document.addEventListener('click', function (event) {
    var el = event.target.closest('[data-whatsapp-checkout]');
    if (!el) return;
    event.preventDefault();
    if (el.hasAttribute('disabled')) return;

    setLoading(el, true);

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items.length) {
          setLoading(el, false);
          return;
        }

        var showRates = el.dataset.showRates === 'true';
        var ratesPromise = showRates ? fetchRates().catch(function () { return null; }) : Promise.resolve(null);

        return ratesPromise.then(function (rates) {
          var message = buildCartMessage(cart, rates, showRates);
          var number = el.dataset.waNumber;
          window.open('https://wa.me/' + number + '?text=' + encodeURIComponent(message), '_blank');
          setLoading(el, false);
        });
      })
      .catch(function () {
        setLoading(el, false);
      });
  });
})();
